import transform from '@/services/tiers/filters/contactServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/Contact/';

export async function get(idContact) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idContact } });
  return response;
}

export async function getAllByTiers(idTiers) {
  const response = await HTTP.get(URL_BASE + 'GetAllByTiersAsync/?TiersId=' + idTiers);
  return response;
}

export async function getAllWithTiers(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllWithTiersAsync', inputServer);
  return response;
}

export async function create(contact) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', contact);
  return response;
}

export async function update(contact) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', contact);
  return response;
}

export async function remove(idContact) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idContact } });
  return response;
}

export async function archiver(listeId) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', listeId);
  return response;
}

export async function deleteAllContacts(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllAsync', ids);
  return response;
}

export async function createAll(listeContacts, modeTest) {
  const mode = modeTest ? '?modeTest=true' : '?modeTest=false';
  const response = await HTTP.post(`${URL_BASE}CreateAllAsync${mode}`, listeContacts);
  return response;
}

export async function updateNewsletter(payload) {
  const response = await HTTP.put(URL_BASE + 'UpdateNewsletterAsync', payload);
  return response;
}
